export const ChampionData = [
  {
    "year": "2019",
    "image": require('../images/Large_2019.svg'),
    "champion": {
      "name": "Julian Marin",
      "costume": "The Swedish Chef",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/1stPlace_Hero_2019_2x_iw3lqf.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Rich Bloom",
        "costume": "\"Macho Man\" Randy Savage",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/2019_2nd_2x_td9iph.jpg"
      },
      {
        "place": "3rd",
        "name": "Adam Ivusich",
        "costume": "Ace Ventura",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/2019_3rd_2x_yfs2rd.jpg"
      },
      {
        "place": "4th",
        "name": "Patrick Quill",
        "costume": "Fat Thor",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/2019_4th_2x_uqq4vj.jpg"
      },
      {
        "place": "5th",
        "name": "Richee Cheng",
        "costume": "Joker",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/2019_5th_2x_kkilus.jpg"
      }
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381630/Previous%20Winners/2019/Year_2019_2x_jbwj8m.jpg"
  },
  {
    "year": "2018",
    "image": require('../images/Large_2018.svg'),
    "champion": {
      "name": "Irina Moiseenko",
      "costume": "Hela the Goddess of Death",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381632/Previous%20Winners/2018/1stPlace_Hero_2018_2x_o7uivq.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Patrick Quill",
        "costume": "Deadpool",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2018/2018_2nd_2x_cpviz2.jpg"
      },
      {
        "place": "3rd",
        "name": "JD Slaughter",
        "costume": "The Gorton's Fisherman",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2018/2018_3rd_2x_o5i3i1.jpg"
      },
      {
        "place": "4th",
        "name": "Megan Ahern",
        "costume": "Mary Poppins",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2018/2018_4th_2x_owhmpq.jpg"
      },
      {
        "place": "5th",
        "name": "Nour Tabet",
        "costume": "Shaman",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2018/2018_5th_2x_t5wpdj.jpg"
      }
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/v1603381631/Previous%20Winners/2018/Year_2018_2x_m0mlxw.jpg"
  },
  {
    "year": "2017",
    "image": require('../images/Large_2017.svg'),
    "champion": {
      "name": "Patrick Quill",
      "costume": "The Night King",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2017/1stPlace_Hero_2017_2x_mds401.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Irina Moiseenko",
        "costume": "Mystique",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381632/Previous%20Winners/2017/2017_2nd_2x_fhfn18.jpg"
      },
      {
        "place": "3rd",
        "name": "Tim Darragh",
        "costume": "Cactus",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381631/Previous%20Winners/2017/2017_3rd_2x_rxp9n3.jpg"
      },
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603742828/Previous%20Winners/2017/Year_2017_2x_syzek7.jpg"
  },
  {
    "year": "2016",
    "image": require('../images/Large_2016.svg'),
    "champion": {
      "name": "Allie Carroll",
      "costume": "Zoltar Speaks",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381633/Previous%20Winners/2016/1stPlace_Hero_2016_2x_ufohxo.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Theo Robinson",
        "costume": "Michael Jackson Thriller",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381632/Previous%20Winners/2016/2016_2nd_2x_xfksme.jpg"
      },
      {
        "place": "3rd",
        "name": "Julian Marin",
        "costume": "Hodor",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381632/Previous%20Winners/2016/2016_3rd_2x_fzv7vm.jpg"
      },
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381632/Previous%20Winners/2016/Year_2016_2x_q0ngxp.jpg"
  },
  {
    "year": "2015",
    "image": require('../images/Large_2015.svg'),
    "champion": {
      "name": "Natalie Eyerman",
      "costume": "Edward Scissorhands",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381634/Previous%20Winners/2015/1stPlace_Hero_2015_2x_fqizkh.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Adrienne Reich",
        "costume": "Jareth the Goblin King",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381633/Previous%20Winners/2015/2015_2nd_2x_t32zob.jpg"
      },
      {
        "place": "3rd",
        "name": "Shannon Stull",
        "costume": "Tina Belcher",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381633/Previous%20Winners/2015/2015_3rd_2x_ns9sma.jpg"
      },
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381634/Previous%20Winners/2015/Year_2015_2x_rwqzwp.jpg"
  },
  {
    "year": "2014",
    "image": require('../images/Large_2014.svg'),
    "champion": {
      "name": "Alex Safchuk",
      "costume": "Greg Wilson",
      "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381635/Previous%20Winners/2014/1stPlace_Hero_2014_2x_va89yg.jpg"
    },
    "placements": [
      {
        "place": "2nd",
        "name": "Natalie Eyerman",
        "costume": "Rust Cohle, True Detective",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381634/Previous%20Winners/2014/2014_2nd_2x_lx4ods.jpg"
      },
      {
        "place": "3rd",
        "name": "Matt Toigo",
        "costume": "Patrick Bateman",
        "image": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381634/Previous%20Winners/2014/2014_3rd_2x_pnjeku.jpg"
      },
    ],
    "team": "//res.cloudinary.com/huge-kyu/image/upload/q_auto/v1603381635/Previous%20Winners/2014/Year_2014_2x_kasj9j.jpg"
  }
]